module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc23",
      "id": "dd23"
    }
  }, [_c('i', [_vm._v("January 21")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary21"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0026-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Every branch in Me that does not bear fruit He takes away")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0026-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("H")]), _vm._v("e is like a refiner’s fire and like launderers’ soap. He will sit as a refiner and a purifier of silver; He will purify the sons of Levi, and purge them as gold and silver, that they may offer to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" an offering in righteousness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-05-6"
    }
  }, [_vm._v("We also glory in tribulations, knowing that tribulation produces perseverance; and perseverance, character; and character, hope. Now hope does not disappoint, because the love of God has been poured out in our hearts by the Holy Spirit who was given to us. • If you endure chastening, God deals with you as with sons; for what son is there whom a father does not chasten? But if you are without chastening, of which all have become partakers, then you are illegitimate and not sons. . . . Now no chastening seems to be joyful for the present, but painful; nevertheless, afterward it yields the peaceable fruit of righteousness to those who have been trained by it. Therefore strengthen the hands which hang down, and the feeble knees.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 15:2; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AL")]), _vm._v(". 3:2–3; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 5:3–5; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 12:7–8, 11–12")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary21"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0026-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("Now we call the proud blessed")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0026-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("hus says the High and Lofty One who inhabits eternity, whose name is Holy: “I dwell in the high and holy place, with him who has a contrite and humble spirit, to revive the spirit of the humble, and to revive the heart of the contrite ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-10-16"
    }
  }, [_vm._v("Better to be of a humble spirit with the lowly, than to divide the spoil with the proud. • Blessed are the poor in spirit, for theirs is the kingdom of heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-10-17"
    }
  }, [_vm._v("These six things the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" hates, yes, seven are an abomination to Him: a proud look. • Everyone proud in heart is an abomination to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-10-18"
    }
  }, [_vm._v("Search me, O God, and know my heart; try me, and know my anxieties; and see if there is any wicked way in me, and lead me in the way everlasting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-10-19"
    }
  }, [_vm._v("Grace to you and peace from God our Father and the Lord Jesus Christ. I thank my God upon every remembrance of you. • Blessed are the meek, for they shall inherit the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AL")]), _vm._v(". 3:15; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 57:15; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 16:19; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 5:3; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 6:16–17; 16:5; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 139:23–24; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 1:2–3; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 5:5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3c3606e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter23.vue
// module id = 132
// module chunks = 0